export default __webpack_public_path__ + "static/media/Bed_exit_monitoring.c6834107.svg";